<template>
<!-- 所有好友页面-->
  <div>
<HeadNav/>
    <div class="d1">
      <div class="d2">{{langUtil(37)}}({{ substringStr(parent,5) }})</div>
      <van-button color="#B9EC54" class="d3" @click="clickShowShare">{{langUtil(8)}}</van-button>
    </div>
    <div class="d1a">
      <van-button color="#B9EC54" class="d3" @click="refresh()">{{langUtil(169)}}</van-button>
    </div>
    <div class="d4">
      <div class="d5" v-for="(item,index) in commissionRelationshipChildren" :key="index" @click="clickChildren(item)">
        <img src="../assets/img/img3.png" alt="" class="d6">
        <div> {{substringStr(item,5)}}</div>
      </div>
    </div>
    <ListEmpty v-if="commissionRelationshipChildren.length === 0" />
    <van-share-sheet
        v-model="showShare"
        :title='this.langUtil(41)'
        :options="options"
        @select="onSelect"
    />
  </div>
</template>

<script>
  import HeadNav from "../components/HeadNav";
  import {Toast} from "vant";
  import {getCommissionRelationshipChildren} from "../tools/chain";
  import {cutPhone1, LZStringCompress} from "../tools";
  import Clipboard from "clipboard";
  import ListEmpty from "../components/ListEmpty";
  import {
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub,
  substringStr,
  substringStr1,
  noRepeat
} from "../tools/indexFun";
  export default {
    name: "allFriends",
    components: {
      HeadNav,
      ListEmpty
    },
    data(){
      return{
        showShare:false,
        options: [
          { name: '复制链接', icon: 'link' },
        ],
        formData:[
          {userName:'adff'}
        ],
        parent: '',
        commissionRelationshipChildren: [],
      }
    },
    methods:{
      onSelect() {
        Toast.success({
          message: this.langUtil(42),
        });
        this.showShare = false;
      },
      async getCommissionRelationshipChildren() {
        this.commissionRelationshipChildren = await this.getChildern(this.parent)
      },
      async getChildern(address_) {
        this.commissionRelationshipChildren = []
        let arr = [];
        const loop = async (address_) => {
          let commissionRelationshipChildren = await getCommissionRelationshipChildren(1, 200, address_);
          arr = await noRepeat(commissionRelationshipChildren);
        }
        await loop(address_)
        return arr;
      },
      refresh() {
        this.parent = this.$store.state.accounts[0];
        this.getCommissionRelationshipChildren();
      },
      clickChildren(parent){
        this.parent = parent;
        this.getCommissionRelationshipChildren();
      },
      cutPhone(phone) {
        return cutPhone1(phone);
      },
      substringStr(str = "", chars = 3){
      return substringStr(str, chars)
    },
    substringStr1(str = "", chars = 10){
      return substringStr1(str, chars)
    },
      clickShowShare(){
        if (this.$store.state.accounts.length === 0) return;
        this.showShare=true;
        setTimeout(async () => {
          await document.querySelector(".van-share-sheet__option").setAttribute('data-clipboard-text', `${window.location.origin}?pass=${LZStringCompress(this.$store.state.accounts[0])}`)
          const clipboard = new Clipboard(".van-share-sheet__option");
          clipboard.on('success',  (e) => {
            e.clearSelection();
            Toast.success({
              message: this.langUtil(42),
            });
          });
        }, 500)
      }
    },
    mounted() {
      this.refresh();
    }

  }
</script>

<style lang="less" scoped>
.d1{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 25px 0;
}
.d1a{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 25px 35px;
  span{
    font-size: 12px;
  }
}
  .d2{
    font-weight: 400;
    font-size: 14px;
    color: black;
  }
  .d3{
    font-size: 12px;
    color: black !important;
    height: 30px;
    border-radius: 17px;
  }
.d5{
  display: flex;
  align-items: center;
  font-size: 10px;
  color: #989898;
  font-weight: 400;
  padding: 0 25px 15px;
}
.d6{
  width: 39px;
  height: 39px;
  margin-right: 15px;
}
</style>
